<template>
  <div id="home">
    <ul class="collection with-header">
      <li class="collection-header" style="text-align:center">
        <h4>Pesanmu untuk Bagas</h4>
        <router-link to="/new"><button type="submit" class="btn green" style="margin-bottom:10px">Tambah Baru</button></router-link>
        <router-link to="/about"><button type="submit" class="btn blue" style="margin-bottom:10px">Tentang Laman Ini</button></router-link>
      </li>
      <li v-for="message in messages" v-bind:key="message.id" class="collection-item">
        {{message.content}}
      </li>
    </ul>
  </div>
</template>

<script>
  import db from './firebaseInit'
  export default {
    name: 'home',
    data () {
      return {
        messages: [],
        loading: true
      }
    },
    created () {
      db.collection('messages').orderBy('content').get().then((querySnapshot) => {
        this.loading = false
        querySnapshot.forEach((doc) => {
          const data = {
            'id': doc.id,
            'content': doc.data().content,
            //next features
            // 'createdAt': doc.data().createdAt
          }
          this.messages.push(data)
        })
      })
    }
  }
</script>
<style scoped>
  .flexbox {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-right: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Home.vue